import React, { Component, Fragment } from 'react';
import { EditorState, AtomicBlockUtils } from 'draft-js';

class InsertYoutube extends Component {
    constructor(props) {
        super(props);
        this.state = {
        openModal: false,
        id: '',
        width: '100%',
        height: '315px'
        }
    }
    handleClickOpen = () => {
        this.setState({
            openModal: !this.state.openModal,
        })
    }
    handleCloseModal = () => {
        this.setState({
            openModal: false,
            id: '',
            width: '100%',
            height: '315px',
        })
    }
    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        })
    };
    addStar = () => {
        const { editorState, onChange } = this.props;
        const {id, width, height} = this.state;
        const contentState = editorState.getCurrentContent();
        const contentStateWithEntity = contentState.createEntity(
            'youtube',
            'IMMUTABLE',
            { id, width, height },
        )
        const entityKey = contentStateWithEntity.getLastCreatedEntityKey()
        const newEditorState = EditorState.set(
            editorState,
            { currentContent: contentStateWithEntity },
        )
        onChange( AtomicBlockUtils.insertAtomicBlock(newEditorState, entityKey, ' '));
        this.handleCloseModal();
      };
    render() {
        const {openModal, id, width, height} = this.state;
        return (
            <Fragment>
                {openModal &&
                <div className="boxModal medium">
                    <div className="overlay show" />
                    <div className="boxDialog fadeinup">
                        <div className="title">
                            <h1>Chèn video Youtube</h1>
                            <span />
                        </div>
                        <div className="content mb-20">
                            <div className="form-control mb-15">
                                <input 
                                type="text" 
                                name="id"
                                className="input-control fullWidth"
                                value={id}
                                placeholder="ID video Youtube"
                                onChange={this.handleChange}
                                />
                            </div>
                            <div className="flex align-items-center">
                                <i className="fal fa-arrows-h mb-15 mr-10" />
                                <div className="form-control mb-15 w-100">
                                    <input 
                                    type="text" 
                                    name="width"
                                    className="input-control fullWidth"
                                    value={width}
                                    placeholder="Chiều rộng"
                                    onChange={this.handleChange}
                                    />
                                </div>
                                <i className="fal fa-arrows-v mb-15 mr-10 ml-15" />
                                <div className="form-control mb-15 w-100">
                                    <input 
                                    type="text" 
                                    name="height"
                                    className="input-control fullWidth"
                                    value={height}
                                    placeholder="Chiều cao"
                                    onChange={this.handleChange}
                                    />
                                </div>
                            </div>
                            {id &&
                            <iframe title={id} width={width} height={height} src={`https://www.youtube.com/embed/${id}`} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
                            }
                        </div>
                        <div className="actions flex justify-content-end">
                            <button className="btn btn-primary mr-10" onClick={this.addStar}>Chèn</button>
                            <button className="btn btn-light" onClick={this.handleClickOpen}>Huỷ</button>
                        </div>
                    </div>
                </div>
                }
                <div className="icon-toolbar-rdw" onClick={this.handleClickOpen}><div className="content"><i className="fab fa-youtube" /></div></div>
            </Fragment>
        )
    }
}

export default InsertYoutube
